import { Model } from '@vuex-orm/core'
import Section from './SectionModel'

export default class ShopModel extends Model {
  static entity = 'shops'

  static nameSingular = 'Shop'
  static namePlural = 'Shops'

  static fields() {
    return {
      id: this.uid(),
      title: this.string(''),
      slug: this.string(''),
      sections: this.hasMany(Section, 'shop_id'),
      contact_email: this.string(''),
      maintenance_mode: this.boolean(0),
      stripe_subscription: this.attr(),
      is_subscribed: this.boolean(0),
      is_dead: this.boolean(0),
      has_active_trial: this.boolean(0),
      street_1: this.attr(),
      street_2: this.attr(),
      city: this.attr(),
      state: this.attr(),
      zip: this.attr(),
      shop_domain: this.attr(),
      support_email: this.attr(),
      instagram: this.attr(),
      facebook: this.attr(),
      twitter: this.attr(),
      not_taking_orders: this.attr(),
      safety_measures: this.attr(),
      hide_address_fields: this.boolean(0),
      capture_payment_info: this.boolean(0),
      require_phone_for_signup: this.boolean(0),
      home_banner: this.attr(),
      hide_home_banner_title: this.boolean(0),
      home_page: this.attr(),
      enable_about_page: this.boolean(0),
      about_page: this.attr(),
      help_page: this.attr(),
      menu_gallery: this.attr(),
      low_stock_warning: this.attr(),
      reject_oversold_orders: this.boolean(0),
      require_prepay: this.boolean(1),
      allow_gift_purchases: this.boolean(0),
      enable_item_dates: this.boolean(0),
      allow_item_dates_toggle: this.boolean(0),
      lead_time_minutes: this.number(0),
      item_oversold_note: this.attr(),
      sales_tax: this.number(0).nullable(),
      delivery_fee: this.number(0).nullable(),
      tip_default: this.number(500),
      payment_info: this.attr(),
      delivery_info: this.attr(),
      pickup_info: this.attr(),
      enable_advanced_payment: this.boolean(0),
      payment_options: this.attr(),
      fulfillment_instructions: this.attr(),
      live_chat_button_id: this.attr(),
      enable_live_chat: this.boolean(0),
      require_app_version_match: this.boolean(),
      google_analytics_id: this.attr(),
      ig_access_token: this.attr(),
      fullstory_id: this.attr(),
      timezone: this.attr(),

      phone: this.attr(),
      phone_normalized: this.attr(),
      owner_first_name: this.string(),
      owner_last_name: this.string(),
      venmo_name: this.attr(),
      paypal_email: this.attr(),
      cashapp: this.attr(),
      zelle_contact: this.attr(),
      applepay_phone: this.attr(),
      cc_instrux: this.attr(),
      cc_phone: this.attr(),
      cash_instrux: this.attr(),
      square_location_id: this.string().nullable(),
      square_app_id: this.string().nullable(),
      square_access_token: this.string().nullable(),
      enable_square_payment: this.boolean(),
      fulfillment_options: this.attr(() => []),
      delivery_slots: this.attr(() => []),
      pickup_slots: this.attr(() => []),
      email_customer_invoices: this.attr(),
      bcc_payment_received_email: this.boolean(),
      new_order_alerts: this.boolean(),
      send_welcome_email: this.boolean(),
      send_payment_received_email: this.boolean(),
      welcome_email_body: this.attr(),
      email_paid_customization: this.string().nullable(),
      email_completed_customization: this.string().nullable(),
      guest_invoice_title: this.attr(),
      meta: this.attr(),
    }
  }

  static fetchBySlug(slug) {
    return this.api().get(`/shops/slug/${slug}`)
  }

  static fetchById(id) {
    return this.api().get(`/shops/${id}`, {
      dataTransformer(response) {
        return response.data.data
      },
    })
  }

  static fetchSettingsById(id) {
    return this.api().get(`/shops/${id}/settings`, { dataKey: 'data' })
  }

  static updateSetting(shopId, settingName, val) {
    return this.api().patch(`/shops/${shopId}`, { [settingName]: val })
  }
  static updateModel(shopId, settings) {
    return this.api().patch(`/shops/${shopId}`, settings)
  }
  static getSubscriptionCheckoutUrl(shopId) {
    return this.api().post(`/shops/${shopId}/subscription`)
  }
  static getStripePortalSession(shopId) {
    return this.api().get(`/shops/${shopId}/subscription/customer-portal`)
  }
}
